import React, { Fragment, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { CardBody } from 'reactstrap';
import { LOGIN_ALERT_REMOVE } from '../../actions/types';
import { connect } from 'react-redux';
import { resetPassword } from '../../api/login/auth';
import PropTypes from 'prop-types';
import store from '../../store';
import { Link } from 'react-router-dom';

const ResetPassword = ({
  resetPassword,
  isAuthenticated,
  isError,
  errMessage,
  isErrorType,
  history,
}) => {
  const [redir, setRedir] = useState(false);
  const [eMessage, setEMessage] = useState(null);
  const [formData, setFormData] = useState({
    otp: '',
    new_password: '',
    confirm_password: '',
  });

  const { otp, new_password, confirm_password } = formData;
  const [showmsg, setShowmsg] = useState('d-none');
  const [showEmsg, setShowEmsg] = useState('d-none');
  const [newpassEye, setNewpassEye] = useState(false);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();

    if (otp === '' || new_password === '') {
      setEMessage('Fields Cannot be empty');
      setShowmsg('d-none');
      setShowEmsg('');
      setTimeout(() => {
        setShowmsg('d-none');
        setEMessage(null);
        setShowEmsg('d-none');
      }, 12000);
    } else {
      if (new_password === confirm_password) {
        const query = window.location.href;
        var url = new URL(query);
        const email = url.searchParams.get('user_email');
        await resetPassword(decodeURIComponent(email), otp, new_password);
      } else {
        setEMessage('Password Does not match');
        setShowmsg('d-none');
        setShowEmsg('');
        setTimeout(() => {
          setShowmsg('d-none');
          setEMessage(null);
          setShowEmsg('d-none');
        }, 12000);
      }
    }
  };

  useEffect(() => {
    if (isError && isErrorType === 'RESET_FAILED') {
      setShowmsg('d-none');
      setShowEmsg('');
      setTimeout(() => {
        store.dispatch({
          type: LOGIN_ALERT_REMOVE,
        });
      }, 12000);
    } else if (isError && isErrorType === 'RESET_SUCCESS') {
      setShowmsg('');
      setShowEmsg('d-none');
      setTimeout(() => {
        store.dispatch({
          type: LOGIN_ALERT_REMOVE,
        });
        setRedir(true);
      }, 5000);
    } else {
      setShowmsg('d-none');
      setShowEmsg('d-none');
    }
  }, [isError, isErrorType]);

  if (isAuthenticated) {
    return <Redirect to='/company-management' />;
  }

  if (redir) {
    return <Redirect to='/login' />;
  }
  return (
    <Fragment>
      <div
        style={{
          width: '100%',
          borderRadius: '0px',
        }}
        className=' py-3 px-3 mt-2'
      >
        <CardBody className='pt-3 pb-3 pl-3 pr-3'>
          <form
            className='form-signin mt-0 mb-0 p-0'
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(e);
            }}
          >
            <h3 className='mb-2'>Reset Password</h3>
            <p className='mb-3 pb-2'>Please Enter Details</p>
            <div className='form-group'>
              {/* <label>OTP</label> */}
              <input
                type='text'
                name='otp'
                value={otp}
                onChange={(e) => onChange(e)}
                className='form-control'
                placeholder='OTP'
                autoFocus
                required
                style={{ fontSize: '16px', height: '44px' }}
                autoComplete={'off'}
                autoSave={'off'}
              />
            </div>
            <div className='form-group'>
              {/* <label>New Password</label> */}
              <input
                type={newpassEye ? 'text' : 'password'}
                value={new_password}
                name='new_password'
                onChange={(e) => onChange(e)}
                className='form-control'
                style={{ fontSize: '16px', height: '44px' }}
                placeholder='New Passwords'
                autoFocus
                required
              />
              <span
                toggle='#newPassword2'
                onClick={(e) => {
                  setNewpassEye(!newpassEye);
                }}
                className={
                  'fa  field-icon font-size-4 toggle-password ' +
                  (newpassEye ? 'fa-eye-slash' : 'fa-eye')
                }
              ></span>
              <span
                title='1: Atleast 15 Characters &#013;2: Atleast 1 uppercase and 1 lowercase &#013;3: Atleast 1 number &#013;4: Atleast 1 special character'
                className={'fa fa-info field-icon font-size-4 toggle-password '}
                style={{ marginRight: '30px' }}
              ></span>
            </div>
            <div className='form-group'>
              {/* <label>Confirm Password</label> */}
              <input
                type='password'
                name='confirm_password'
                value={confirm_password}
                onChange={(e) => onChange(e)}
                className='form-control'
                style={{ fontSize: '16px', height: '44px' }}
                placeholder='Confirm Password'
                required
              />
              <button
                className='btn btn-lg mb-2 mt-4 btn-primary btn-block btn-signin'
                type='submit'
              >
                Submit
              </button>
              <div className='col-12' style={{ overflow: 'auto' }}>
                <Link
                  to='/login'
                  style={{
                    width: '100%',
                    textAlign: 'right',
                    float: 'right',
                  }}
                  data-original-title=''
                  title=''
                >
                  Login
                </Link>
              </div>
              <div className={'col-12 p-0 m-0 ' + showmsg}>
                <div
                  className='alert alert-success alert-dismissible fade show mb-0 mt-3'
                  role='alert'
                >
                  {errMessage}
                </div>
              </div>
              <div className={'col-12 p-0 m-0 ' + showEmsg}>
                <div
                  className='alert alert-danger alert-dismissible fade show mb-0 mt-3'
                  role='alert'
                >
                  {eMessage === null ? errMessage : eMessage}
                </div>
              </div>
            </div>
          </form>
        </CardBody>
      </div>
    </Fragment>
  );
};

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isError: PropTypes.bool,
  isErrorType: PropTypes.string,
  errMessage: PropTypes.string,
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isError: state.auth.isError,
  errMessage: state.auth.errMessage,
  isErrorType: state.auth.isErrorType,
});
export default connect(mapStateToProps, { resetPassword })(ResetPassword);
